import React, { useState, useEffect, useMemo } from "react";
import Split from "react-split";

import SimpleMDE from "react-simplemde-editor";
import "easymde/dist/easymde.min.css";

import marked from "marked";

import "./MarkdownEditor.css";
import markdownPreview from "./markdown-preview.md";

const Index = () => {
  const [text, setText] = useState("");

  useEffect(() => {
    const loadPreview = async () => {
      const response = await fetch(markdownPreview);
      const ressponeText = await response.text();
      setText(ressponeText);
    };

    loadPreview();
  }, []);

  const formattted = useMemo(() => marked(text, { sanitize: true }), [text]);

  return (
    <Split className="formatter-split">
      <SimpleMDE
        className="formatter-editor"
        value={text}
        onChange={(value) => setText(value)}
      />
      <div dangerouslySetInnerHTML={{ __html: formattted }} />
    </Split>
  );
};

export default Index;
